class Modal {
  constructor({
    elementId,
    onOpenCallback = () => {},
    onCloseCallback = () => {},
  }) {
    const modal = document.getElementById(elementId);
    this._modal = modal;

    this._onOpenCallback = onOpenCallback.bind(this);
    this._onCloseCallback = onCloseCallback.bind(this);

    this.boundClose = this.close.bind(this);
    this.boundHandleKeyDown = this._handleKeyDown.bind(this);
  }

  get modal() {
    return this._modal;
  }

  _toggle() {
    this._modal.classList.toggle("show");
    document.body.classList.toggle("no-scroll");
  }

  open(callback = () => {}) {
    this._toggle();
    callback();
    this._onOpenCallback();

    const closeButton = this.modal.querySelector(".close-container");
    const modalBackground = this.modal.querySelector(".modal-background");

    if (closeButton) {
      closeButton.addEventListener("click", this.boundClose);
    }

    if (modalBackground) {
      modalBackground.addEventListener("click", this.boundClose);
    }

    document.addEventListener("keydown", this.boundHandleKeyDown);
  }

  close() {
    const closeButton = this.modal.querySelector(".close-container");
    const modalBackground = this.modal.querySelector(".modal-background");

    if (closeButton) {
      closeButton.removeEventListener("click", this.boundClose);
    }

    if (modalBackground) {
      modalBackground.removeEventListener("click", this.boundClose);
    }

    document.removeEventListener("keydown", this.boundHandleKeyDown);

    this._toggle();
    this._onCloseCallback();
  }

  _handleKeyDown(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }
}

export default Modal;